import { isEmpty } from 'remeda'
import { useCart } from '@velasca/hooks/use-cart'
import { useCartSuggestedProducts } from '@velasca/hooks/use-cart-suggested-products'
import { trackEvent } from '@velasca/utils/track-event'
import { Content, StyledProductSlider } from './DesktopSuggestedProducts.styles'

export const DesktopSuggestedProducts = () => {
  const {
    data,
    error,
    title,
    subtitle,
    onAddToCartAddeventName,
    onQuickAddEventName,
  } = useCartSuggestedProducts()
  const { suggestedProductsHandle } = useCart()

  // Since we don't know if recent or complementary have some data, we just cannot show a loading state with a skeleton. That' why we are ignoring the loading state and simply return null
  if (error || isEmpty(data)) {
    return null
  }

  return (
    <Content>
      <StyledProductSlider
        showProductType
        slidesSize="dynamic-size"
        products={data}
        title={title}
        subTitle={subtitle}
        onQuickAdd={() => {
          onAddToCartAddeventName &&
            trackEvent({
              googleAnalytics: {
                eventName: onQuickAddEventName,
                data: { handle: suggestedProductsHandle },
              },
            })
        }}
        onAddToCart={(handle) => {
          onAddToCartAddeventName &&
            trackEvent({
              googleAnalytics: {
                eventName: onAddToCartAddeventName,
                data: { handle },
              },
            })
        }}
      />
    </Content>
  )
}
